import './App.css';
import SearchBar from '../SearchBar/SearchBar';
import BusinessList from '../BusinessList/BusinessList'
import React from 'react';
import Yelp from '../../Util/Yelp'




class App extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      businesses: []
    }
    this.searchYelp = this.searchYelp.bind(this)
  }
  searchYelp(term, location, sortBy) {
      Yelp.searchYelp(term, location, sortBy).then((businesses) => {
          this.setState({
            businesses: businesses
          })
      })
      console.log("Hello")
  }
  
  render() {
    return (
      
      <div class="App">
    <h1>ravenous</h1>
    <SearchBar searchYelp={this.searchYelp}/>
    <BusinessList businesses={this.state.businesses} />
  </div>
  
  );
}
}

export default App;
